import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import '../styles/AddParticipant.css';

function AddParticipant({ session, onAddParticipant, isAdmin, onBlockSession }) {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [playerCount, setPlayerCount] = useState(1);
  const [ages, setAges] = useState(''); // ← NOUVEAU STATE
  const [paid, setPaid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [wantToBlock, setWantToBlock] = useState(false);
  const [blockReason, setBlockReason] = useState('');

  // EmailJS config
  const EMAILJS_SERVICE_ID = 'service_yv02dnf';
  const EMAILJS_TEMPLATE_ID = 'template_a2rips3';
  const EMAILJS_PUBLIC_KEY = 'NDZ3UQiorhMdJfkEb';

  if (!session) {
    return (
      <div className="no-session-selected">
        <p>Aucune session sélectionnée.</p>
        <button onClick={() => navigate('/')} className="calendar-button">
          Retour au calendrier
        </button>
      </div>
    );
  }

  // Formatage de la date en français
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Générer un numéro de confirmation unique
  const generateConfirmationNumber = () => {
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substr(2, 5);
    return `LT-${timestamp}-${random}`.toUpperCase();
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email && emailRegex.test(email.trim());
  };

  // Envoi email de confirmation avec toutes les informations
  const sendConfirmationEmail = async (participantData, confirmationNumber) => {
    const emailToSend = participantData.email?.trim();
    if (!validateEmail(emailToSend)) {
      return { success: false, message: 'Email invalide' };
    }
    try {
      const templateParams = {
        to_email: emailToSend,
        nom_participant: participantData.name?.trim() || 'Non renseigné',
        telephone_participant: participantData.phone?.trim() || 'Non renseigné',
        email_participant: emailToSend,
        date_session: formatDate(session.date),
        heure_session: session.time,
        nombre_joueurs: participantData.playerCount || 1,
        numero_confirmation: confirmationNumber,
        adresse_centre: "53 la Charrière du Commerce, 50230 Agon-Coutainville",
        telephone_centre: "02 44 84 99 96",
        email_centre: "laserbayagon@gmail.com",
        site_centre: "laserbay.net",
        prix_unitaire: "12€ par personne pour 30 minutes", // ← MODIFIÉ
        prix_total: `${(participantData.playerCount || 1) * 12}€ (pour 30 minutes)`, // ← MODIFIÉ
        annee_actuelle: new Date().getFullYear(),
        nom_centre: "Centre Équestre Agon-Coutainville",
        message_bienvenue: "Bienvenue au Laser Tag !",
        instructions_arrivee: "Merci d'arriver 15 minutes avant le début de la session",
        tenue_recommandee: "Venir de préférence avec une tenue de sport",
        parking_disponible: "Parking disponible au centre équestre",
        moyens_paiement: "Carte bancaire, espèces, chèques, chèques vacances acceptés",
        buvette_info: "Buvette disponible sur place",
        delai_annulation: "En cas d'empêchement, merci de nous prévenir au moins 24h à l'avance",
        duree_session: "Cette réservation est pour 30 minutes. Pour prolonger, réservez un créneau supplémentaire.",
        reduction_info: "Des réductions de groupe seront automatiquement appliquées sur place selon la taille de votre groupe." // ← MODIFIÉ
      };

      console.log('📧 Envoi email avec numéro de confirmation:', confirmationNumber);
      console.log('📧 Paramètres complets:', templateParams);

      const result = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      console.log('✅ Email envoyé avec succès:', result);
      return {
        success: true,
        message: `Email de confirmation envoyé à ${emailToSend}`,
        confirmationNumber
      };

    } catch (error) {
      console.error('❌ Erreur EmailJS:', error);
      return {
        success: false,
        message: 'Erreur lors de l\'envoi de l\'email',
        error: error.message
      };
    }
  };

  // Envoi email de notification à l'admin
  const sendAdminNotification = async (participantData, confirmationNumber) => {
    try {
      const templateParams = {
        numero_confirmation: confirmationNumber,
        participant_name: participantData.name?.trim() || 'Non renseigné',
        participant_phone: participantData.phone?.trim() || 'Non renseigné',
        participant_email: participantData.email?.trim() || 'Non renseigné',
        date_session: formatDate(session.date),
        heure_session: session.time,
        nombre_joueurs: participantData.playerCount || 1,
        prix_total: `${(participantData.playerCount || 1) * 12}€`, // ← MODIFIÉ
        statut_paiement: participantData.paid ? 'Payé' : 'Non payé',
        type_reservation: wantToBlock ? 'Groupe privé - Session bloquée' : 'Réservation standard',
        raison_blocage: wantToBlock ? blockReason.trim() : 'N/A',
        timestamp: new Date().toLocaleString('fr-FR'),
        capacite_restante: wantToBlock ? 'Session complète (bloquée)' : `${10 - (participantData.playerCount || 1)} places restantes`,
      };

      console.log('📧 Envoi notification admin:', templateParams);

      const result = await emailjs.send(
        EMAILJS_SERVICE_ID,
        'template_b4wys79', // ou 'template_admin_notification'
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      console.log('✅ Notification admin envoyée:', result);
      return {
        success: true,
        message: 'Notification admin envoyée'
      };

    } catch (error) {
      console.error('❌ Erreur notification admin:', error);
      return {
        success: false,
        message: 'Erreur notification admin',
        error: error.message
      };
    }
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name?.trim()) {
      alert("❌ Veuillez entrer un nom complet.");
      return;
    }
    if (!phone?.trim()) {
      alert("❌ Veuillez entrer un numéro de téléphone.");
      return;
    }
    if (!email?.trim()) {
      alert("❌ L'email est obligatoire pour confirmer votre réservation.");
      return;
    }
    if (!validateEmail(email)) {
      alert("❌ Veuillez entrer une adresse email valide.");
      return;
    }
    if (!ages?.trim()) {
      alert("❌ Veuillez indiquer l'âge des joueurs.");
      return;
    }
    if (wantToBlock && !blockReason?.trim()) {
      alert("❌ Veuillez indiquer la raison du blocage de la session.");
      return;
    }

    setIsSubmitting(true);

    // Modifier participantData pour inclure les âges
    const participantData = {
      name: name.trim(),
      phone: phone.trim(),
      email: email.trim(),
      playerCount: parseInt(playerCount, 10) || 1,
      ages: ages.trim(), // ← NOUVEAU CHAMP
      paid: isAdmin ? paid : false
    };

    try {
      // GÉNÉRER LE NUMÉRO DE CONFIRMATION ICI
      const confirmationNumber = generateConfirmationNumber();
      console.log('🔖 Numéro généré:', confirmationNumber);

      // Vérification de l'heure de la session
      const now = new Date();
      const sessionDate = new Date(session.date + 'T' + session.time); // session.time au format "HH:mm"

      // Ajoute 1h30 (90 minutes) à l'heure actuelle
      const limitDate = new Date(now.getTime() + 90 * 60000);

      if (sessionDate <= limitDate) {
        alert("Il n'est plus possible de réserver pour cette session. Les réservations doivent être faites au moins 1h30 à l'avance.");
        return;
      }

      // Blocage de session pour groupe
      if (wantToBlock) {
        // 1. Ajoute le participant/groupe à la session AVANT de bloquer
        const addSuccess = await onAddParticipant(participantData);
        if (!addSuccess) {
          alert("❌ Erreur lors de l'ajout du groupe.");
          setIsSubmitting(false);
          return;
        }

        // 2. Bloque la session (en passant éventuellement l'id du participant/groupe)
        const blockSuccess = await onBlockSession(
          session.id, 
          `Réservé - ${blockReason.trim()}`,
          true, // isGroupReservation = true
          participantData // groupData
        );
        
        if (blockSuccess) {
          // ENVOYER L'EMAIL AU CLIENT
          const emailResult = await sendConfirmationEmail(participantData, confirmationNumber);

          // ENVOYER LA NOTIFICATION À L'ADMIN
          const adminResult = await sendAdminNotification(participantData, confirmationNumber);

          if (emailResult.success) {
            alert(`🎉 Session bloquée avec succès pour votre groupe !\n\n📧 ${emailResult.message}\n🔖 Numéro de confirmation: ${confirmationNumber}\n\n⏱️ Session réservée pour 30 minutes.\nPour prolonger, contactez-nous ou réservez un créneau supplémentaire.`);
          } else {
            alert(`✅ Session bloquée avec succès !\n🔖 Numéro: ${confirmationNumber}\n\n⚠️ Problème email: ${emailResult.message}`);
          }
          navigate(`/session/${session.id}`);
          return;
        } else {
          alert("❌ Erreur lors du blocage de la session.");
          return;
        }
      }

      // Réservation normale
      const success = await onAddParticipant(participantData);

      if (success) {
        // ENVOYER L'EMAIL AU CLIENT
        const emailResult = await sendConfirmationEmail(participantData, confirmationNumber);

        // ENVOYER LA NOTIFICATION À L'ADMIN
        const adminResult = await sendAdminNotification(participantData, confirmationNumber);

        if (emailResult.success) {
          alert(`🎉 Réservation confirmée !\n\n📧 ${emailResult.message}\n🔖 Numéro de confirmation: ${confirmationNumber}\n\n💰 Tarif: 12€ par personne\n🎉 Réductions de groupe appliquées sur place\n⏱️ Réservation pour 30 minutes.\n💡 Pour prolonger, réservez un créneau supplémentaire.`);
        } else {
          alert(`✅ Réservation confirmée !\n🔖 Numéro: ${confirmationNumber}\n\n⚠️ Problème email: ${emailResult.message}`);
        }
        navigate(`/session/${session.id}`);
      } else {
        alert("❌ Erreur lors de l'ajout du participant.");
      }
    } catch (error) {
      console.error('Erreur lors de la soumission:', error);
      alert("❌ Erreur lors de l'ajout du participant.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-participant-container">
      <h1>Ajouter un participant à la session</h1>
      <div className="session-details">
        <h2>Détails de la session</h2>
        <p><strong>Date:</strong> {formatDate(session.date)}</p>
        <p><strong>Heure:</strong> {session.time}</p>
        <p><strong>Durée:</strong> 30 minutes</p>
        <p><strong>Prix:</strong> 12€ par personne</p> {/* ← MODIFIÉ */}
        <p><strong>Places restantes:</strong> {10 - (session.participants?.length || 0)}</p>
        <p><strong>Réductions:</strong> Des réductions de groupe seront appliquées sur place</p> {/* ← NOUVEAU */}
      </div>
      <form onSubmit={handleSubmit} className="participant-form">
        <div className="form-group">
          <label htmlFor="name">Nom complet:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Numéro de téléphone:</label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Adresse email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="playerCount">👥 Nombre de joueurs * :</label>
          <input
            type="number"
            id="playerCount"
            value={playerCount}
            onChange={(e) => {
              const value = e.target.value;
              // Permettre la saisie vide temporairement
              if (value === '') {
                setPlayerCount('');
              } else {
                const numValue = parseInt(value, 10);
                // Valider entre 1 et 30
                if (!isNaN(numValue) && numValue >= 1 && numValue <= 30) {
                  setPlayerCount(numValue);
                }
              }
            }}
            onBlur={(e) => {
              // Si le champ est vide quand on perd le focus, remettre 1
              if (e.target.value === '' || parseInt(e.target.value) < 1) {
                setPlayerCount(1);
              }
            }}
            onFocus={(e) => {
              // Sélectionner tout le texte au focus pour faciliter la saisie
              e.target.select();
            }}
            min="1"
            max="30"
            className="form-input"
            placeholder="Nombre de joueurs"
            required
          />
          <small style={{ color: '#666', fontSize: '0.9em', display: 'block', marginTop: '5px' }}>
            Entre 1 et 30 joueurs maximum
          </small>
        </div>
        <div className="form-group">
          <label htmlFor="ages">🎂 Âges des joueurs * :</label>
          <input
            type="text"
            id="ages"
            value={ages}
            onChange={(e) => setAges(e.target.value)}
            className="form-input"
            placeholder="Ex: 12, 14, 16 ans ou 25-30 ans"
            required
          />
          <small style={{ color: '#666', fontSize: '0.9em', display: 'block', marginTop: '5px' }}>
            Indiquez l'âge de chaque joueur (séparés par des virgules)
          </small>
        </div>
        {/* Case "Déjà payé" - SEULEMENT pour les admins */}
        {isAdmin && (
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={paid}
                onChange={(e) => setPaid(e.target.checked)}
              />
              💳 Paiement effectué
            </label>
          </div>
        )}
        <div className="form-group">
          <label>
            <input
              type="checkbox"
              checked={wantToBlock}
              onChange={(e) => setWantToBlock(e.target.checked)}
            />
            Bloquer cette session pour un groupe privé <span style={{fontWeight: 400}}>(le prix s’appliquera pour 10 personnes)</span>
          </label>
        </div>
        {wantToBlock && (
          <div className="form-group">
            <label htmlFor="blockReason">Raison du blocage:</label>
            <input
              type="text"
              id="blockReason"
              value={blockReason}
              onChange={(e) => setBlockReason(e.target.value)}
              required
            />
          </div>
        )}
        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Enregistrement...' : 'Enregistrer le participant'}
          </button>
          <button onClick={() => navigate(-1)} className="cancel-button">
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddParticipant;